module.exports = __webpack_public_path__ + "img/dodge.72c3e893.svg";